module.exports = __webpack_public_path__ + "static/media/sloanes-viperfish.91b97237.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/sloanes-viperfish.png
// module id = 334
// module chunks = 0